import { Component, OnInit } from "@angular/core";
import { Router , NavigationEnd, ActivatedRoute, NavigationStart, RouteConfigLoadEnd} from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { ImageUrls } from "src/app/services/s3buket";
import { UserDetailsService } from "../../services/user/user-details.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
   dummyImage: any;
   globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users;
   userDatas: any;

   sideBarLinks : any = []

   constructor ( private router: Router, public route: ActivatedRoute, private api: AdminService, private userDetailsService: UserDetailsService ) {
    this.userDetailsService.userDetailsObserver.subscribe(userData => {
      this.userDatas = userData;
    });
    router.events.subscribe ( ( val ) => { 
      if (val instanceof NavigationEnd) {
        this.checkSideList(val.urlAfterRedirects)
      }
    })
    }
 
   ngOnInit(): void { 
      this.checkSideList( this.router.url )
   }  

   checkSideList( url ) {
    this.sideBarLinks = [{name: "skills"}, {name: "education"}, {name:"experience"},
      {name: "volunteer"}, {name: "projects"}, {name: "awards"}, {name: "licenese"}, {name:"language"}, {name: "jobs"}]
      for(let i=0; i<this.sideBarLinks.length; i++) {
        this.sideBarLinks[i]["selected"] = true;
        if (url.toString().includes(this.sideBarLinks[i].name)) {
          break;
        }
      }
   }
 }
 